export default {"src":"/_next/static/media/home-sketch.9bb84f05.svg","height":18,"width":112};